// src/views/TermsPage.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-slate-900 text-white">
      <Helmet>
        <title>Terms of Use | Spatchy</title>
        <meta name="description" content="Spatchy Terms of Use — the rules and conditions governing use of the platform." />
      </Helmet>

      {/* Header */}
      <div className="border-b border-white/10 bg-slate-900/80 backdrop-blur-sm">
        <div className="max-w-4xl mx-auto px-6 py-8">
          <h1 className="text-3xl font-bold text-white">Terms of Use</h1>
          <p className="text-slate-400 mt-2 text-sm">
            The terms and conditions governing your use of Spatchy.
          </p>
        </div>
      </div>

      {/* Termly Embed */}
      <div className="max-w-4xl mx-auto px-6 py-10">
        <div className="bg-white rounded-xl overflow-hidden shadow-2xl">
          <iframe
            src="https://app.termly.io/policy-viewer/policy.html?policyUUID=f28a45fe-12b6-4f42-99f7-7e72c4731413"
            title="Spatchy Terms of Use"
            className="w-full"
            style={{ height: '80vh', minHeight: '600px', border: 'none' }}
          />
        </div>
      </div>
    </div>
  );
};

export default TermsPage;